import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal.js'
import CPassModal from '../../components/CPassModal.js'
import ModalHelp from '../../components/ModalHelp.js'
import CStatusModal from '../../components/CStatusModal.js'
import Paging from '../../components/Paging'
import qs from 'qs'
import queryString from 'query-string'
import fp from 'lodash/fp'
import FormDropdown from '../../components/FormDropdown'
import XLSX from 'xlsx'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown
} from "reactstrap";

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';

const normalizeLevelName = (str) => {
    return fp.startCase(str.replace("_", " "))
}

// const yourDate = new Date()
const NewDateStart  = moment().format('YYYY-MM-DD')
const NewDateEnd    = moment().add(1, 'days').format('YYYY-MM-DD')

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            dataUsers    : [],
            dataExport   : [], // data export siswa
            dataExportGuru  : [], // data export guru
            dataKelas    : [],
            dataExportSiswa:[],
            pageCount    : 0,
            totaldata    : 0,
            currentPage  : 0,
            user_id      : 0,
            kelas_id     : "",
            no     : 0,
            user_level   : "",
            tutorial    : "",
            user_name    : "",
            dateNowStart : NewDateStart,
            dateNowEnd   : NewDateEnd,
            dateStart    : moment(),
            dateEnd      : moment(),
			date         : moment(),
            isLoading    : true,
            isModalShow  : false,
            isModalHelpShow  : false,
            isModalPassShow  : false,
            isModalStatusShow  : false,
            statusExist : '',
            dropdownOpen: false,
            sortName : '',
            sortOrder : '',
            startNo : 1,
        }

        this.toggleModal                = this.toggleModal.bind(this)
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
        this.toggleModalPass            = this.toggleModalPass.bind(this)
        this.toggleModalStatus          = this.toggleModalStatus.bind(this)
        this.handleSubmitDeleteButton   = this.handleSubmitDeleteButton.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handlePageClick            = this.handlePageClick.bind(this)
        this.exportFile                 = this.exportFile.bind(this); //presensi siswa
        this.exportFileGuru                = this.exportFileGuru.bind(this); //presensi guru
        this.handleChangeDatepickerStart   = this.handleChangeDatepickerStart.bind(this);
        this.handleChangeDatepickerEnd     = this.handleChangeDatepickerEnd.bind(this);
        this.handleChangeDatepickerStartGuru   = this.handleChangeDatepickerStartGuru.bind(this);
        this.handleChangeDatepickerEndGuru     = this.handleChangeDatepickerEndGuru.bind(this);
        this.toggle     = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    toggleModalHelp(levelName) {
    // alert(levelName)
        if (levelName == 'Pengguna Umum'){
            this.setState({tutorial : 'https://www.youtube.com/embed/sRmKKvXjSg8'})
        }else if(levelName == 'Siswa'){
            this.setState({tutorial : 'https://www.youtube.com/embed/KCwuTHv5ZR4'})
        }else if(levelName == 'Wali'){
            this.setState({tutorial : 'https://www.youtube.com/embed/um0SY_jYJpw'})
        }else {
            this.setState({tutorial : 'https://www.youtube.com/embed/-8Pze48C6jw'})
        }

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }

    toggleModalPass() {
        this.setState({ isModalPassShow: ! this.state.isModalPassShow})
    }

    toggleModalStatus() {
        this.setState({ isModalStatusShow: !this.state.isModalStatusShow},()=>{
            if(!this.state.isModalStatusShow){
                this.loadData()
            }
        })
    }

    handleSubmitDeleteButton() {

        let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		this.setState({ isButtonLoading: true })

		const aksi = this.props.mode === "Edit" ? "edit" : "add"

		formData.append('user_id', this.state.user_id)
		formData.append('user_level', this.state.user_level)

		axios.post("/user/delete/"+ this.state.user_id, formData, config)
        // alert(this.state.user_level)
        // axios({
        //     method: 'post',
        //     url: '/user/delete/' + this.state.user_id + '?user_id=' + this.state.user_id 
        // })
        .then(response => {
            
            Alert.success("Data berhasil dihapus");
            this.loadData();
            this.loadExport();
            this.toggleModal();
            return;
        })
        .catch(error => {
            console.log(error)
            this.setState({isLoading: false})
            Alert.error("Gagal terhubung ke server!")
        })
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
            this.loadExport();
        });
    };

    handleChangeDatepickerStart(e) {
        this.setState({
            dateStart:e,
            dateNowStart:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadExport();                
                this.loadData();
            })
    }

    handleChangeDatepickerEnd(e) {
        this.setState({
            dateEnd:e,
            dateNowEnd:e.add(1, 'days').format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadExport();
                this.loadData();
            })
    }

    handleChangeDatepickerStartGuru(e) {
        this.setState({
            dateStart:e,
            dateNowStart:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadExportGuru();                
                this.loadData();
            })
    }

    handleChangeDatepickerEndGuru(e) {
        this.setState({
            dateEnd:e,
            dateNowEnd:e.add(1, 'days').format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadExportGuru();
                this.loadData();
            })
    }

    exportFile() { 

        let presensi = [["No","Nama Siswa","NISN", "RFID", "Kelas", "Level", "Status", "Nama Wali", "User Wali", "Password Wali"]]
        
		this.state.dataExport.map((item,i) => {
            presensi.push([
                i+1, 
                item.nama_siswa,
                item.siswa_nisn,  
                item.siswa_rfid, 
                item.kelas_nama,
                item.user_level, 
                item.user_status === "1" ? "Aktif" : "Non Aktif", 
                item.nama_wali,
                item.user_name_wali,
                item.pass_wali
            ])
		})
		const wb = XLSX.utils.book_new()
		const wsAll = XLSX.utils.aoa_to_sheet(presensi)
            XLSX.utils.book_append_sheet(wb, wsAll, "Data Siswa Aktif")

            if (this.state.kelas_id === "") {
                XLSX.writeFile(wb, "Rekap Data Siswa Aktif-"+ moment().format("DD-MMMM-YYYY") +".xlsx")
            }else{
                XLSX.writeFile(wb, "Rekap Data Siswa Aktif Per Kelas-"+ moment().format("DD-MMMM-YYYY") +".xlsx")
            }
    }

    exportFileGuru() { 
        let presensi = [["No","Nama Lengkap","NIP", "RFID", "Level", "Status"]]
        
		this.state.dataExportGuru.map((item,i)  => {
            presensi.push([
                i+1, 
                item.user_nama,
                item.guru_nip, 
                item.guru_rfid, 
                item.user_level, 
                item.user_status === "1" ? "Aktif" : "Non Aktif"
            ])
		})
		const wb = XLSX.utils.book_new()
		const wsAll = XLSX.utils.aoa_to_sheet(presensi)
			XLSX.utils.book_append_sheet(wb, wsAll, "Data Guru Aktif")
			XLSX.writeFile(wb, "Rekap Data Guru Aktif-"+ moment().format("DD-MMMM-YYYY") +".xlsx")
    }

    loadExport() { //siswa

        const urlParams = queryString.parse(this.props.location.search);        

        let sortirLevel;

        switch (urlParams.l) {
            case "siswa":
                sortirLevel = "siswa"
                break;
            default:
                sortirLevel = "umum"
        }
        
        // this.setState({ isLoading: true })

        const params = qs.stringify({
            level: sortirLevel,
            cari: this.state.user_name,
            kelas: this.state.kelas_id
        })

        axios.post("/exportsiswa?" + params)
            .then(response => {
                const result = response.data
                this.setState({
                    dataExport  : result.data,
                })
            })
            .catch((error) => {
                
                console.log(error)
                this.setState({ isLoading: false })
                // Alert.error("Gagal terhubung ke server!")
            })
    }

    loadExportGuru() { //guru

        const urlParams = queryString.parse(this.props.location.search);        

        let sortirLevel;

        switch (urlParams.l) {
            case "guru":
                sortirLevel = "guru"
                break;
            default:
                sortirLevel = "umum"
        }
        
        // this.setState({ isLoading: true })

        const params = qs.stringify({
            level: sortirLevel,
            cari: this.state.user_name
        })

        axios.post("/exportguru?" + params)
            .then(response => {
                const result = response.data
                this.setState({
                    // console.log("=>", result.data)
                    dataExportGuru  : result.data,
                })
            })
            .catch((error) => {
                
                console.log(error)
                this.setState({ isLoading: false })
            })
    }
    
    loadData() {

        const urlParams = queryString.parse(this.props.location.search);        

        let sortirLevel;

        switch (urlParams.l) {
            case "siswa":
                sortirLevel = "siswa"
                break;
            case "wali":
                sortirLevel = "wali"
                break;
            case "guru":
                sortirLevel = "guru"
                break;
            default:
                sortirLevel = "umum"
        }
        
        this.setState({ isLoading: true })

        const params = qs.stringify({
            page : this.state.currentPage + 1,
            level: sortirLevel,
            cari: this.state.user_name,
            kelas: this.state.kelas_id,
            sortName : this.state.sortName,
            sortOrder : this.state.sortOrder
        })
                       
        axios.post("/user?" + params)
            .then(response => {

                const result = response.data
                this.setState({
                    dataUsers  : result.data.data,
                    pageCount  : result.data.last_page,
                    totaldata   : result.data.total,
                    startNo : result.data.from,
                    sortName : this.state.sortName,
                    sortOrder : this.state.sortOrder,
                    isLoading  : false
                })
            })
            .catch((error) => {
                
                console.log(error)

                this.setState({ isLoading: false })

                Alert.error("Gagal terhubung ke server!")
            })
    }

    loadDataKelas() {

        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }
    
    componentDidMount() {

		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
        
        const urlParams = queryString.parse(this.props.location.search);        
        let sortirLevel;

        switch (urlParams.l) {
            case "siswa":
                sortirLevel = "siswa"
                break;
            case "guru":
                sortirLevel = "guru"
                break;
            default:
                sortirLevel = "umum"
        }

        if(sortirLevel === 'siswa'){
            this.loadExport();
        }else if(sortirLevel === 'guru'){
            this.loadExportGuru();
        }

        this.loadData()
        this.loadDataKelas()
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.location.search !== this.props.location.search || 
            prevState.user_name !== this.state.user_name
            || prevState.kelas_id !== this.state.kelas_id
            || prevState.sortName !== this.state.sortName
            || prevState.sortOrder !== this.state.sortOrder
        ) {
            this.loadData()
            this.loadExport()
            this.loadExportGuru()
        }
    }

    onSortChange(sortName, sortOrder) {
        this.setState({
            sortName,
            sortOrder
        });
    }

    formatOpsi(cell, row, enumObject, index){
        const urlParams = queryString.parse(this.props.location.search);

        let sortirLevel;
        let levelName;
        let kelas

        switch (urlParams.l) {
            case "siswa":
                kelas = null
                sortirLevel = "siswa"
                levelName = "Siswa"
                break;
            case "wali":
                sortirLevel = "wali"
                levelName = "Wali"
                break;
            case "guru":
                sortirLevel = "guru"
                levelName = "Guru"
                break;
            default:
                sortirLevel = "umum"
                levelName = "Pengguna Umum"
        }
        const url = this.props.match.url;

        return (
            <div>
                {
                    row.user_username !== "root@master.com" &&
                    <NavLink
                        to={`${url}/${row.user_level}/${row.user_id}`}
                        title='Edit'
                        className="btn btn-danger btn-sm"
                    >
                        <i className="fa fa-pencil" title="Edit"></i>
                    </NavLink>
                }
                {" "}
                {
                    row.user_level === "guru" ? (
                        <NavLink
                            to={`${url}/setting/${row.user_id}`}
                            title='Pengaturan'
                            className="btn btn-danger btn-sm"
                        >
                            <i className="fa fa-gear" title="Pengaturan"></i>
                        </NavLink>
                    ) : " "
                }
                {" "}
                {row.user_username !== "root@master.com" ? (
                    <button
                        type="button"
                        title='Hapus'
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                            this.toggleModal();
                            this.setState({ user_id: row.user_id});
                        }}
                    >
                        <i className="fa fa-trash" title="Hapus"></i>
                    </button>

                ):""}
                {" "}
                {row.user_username !== "root@master.com" ? (
                    <button
                        onClick={() => {
                            this.toggleModalPass();
                            this.setState({
                                userId: row.user_id,
                                userNama: row.user_nama,
                                userUserName: row.user_username
                            });
                        }}
                        className="btn btn-danger btn-sm"
                        title="Password">
                        <i className="fa fa-key" title="Ubah Password"></i>
                    </button>

                ):" "}
                {" "}
                { sortirLevel === "siswa" ? (
                    <button
                        onClick={() => {
                            this.toggleModalStatus();
                            this.setState({
                                userId: row.user_id,
                                userNama: row.user_nama,
                                userUserName: row.user_username,
                                statusExist : row.user_status
                            });
                        }}
                        className={row.user_status === '1' ? "btn btn-sm btn-danger" :  "btn btn-sm btn-primary"}
                        style={{ margin:'10px'}}
                    >
                        {row.user_status === '1' ? 'Set Non-Active' : 'Aktifkan User' }
                    </button>
                ):""}
            </div>
        )
    }

    render () {
        const urlParams = queryString.parse(this.props.location.search);
        const strt = this.state.startNo

        let sortirLevel;
        let levelName;
        let kelas

        switch (urlParams.l) {
            case "siswa":
                kelas = null
                sortirLevel = "siswa"
                levelName = "Siswa"
                break;
            case "wali":
                sortirLevel = "wali"
                levelName = "Wali"
                break;
            case "guru":
                sortirLevel = "guru"
                levelName = "Guru"
                break;
            default:
                sortirLevel = "umum"
                levelName = "Pengguna Umum"
        }
        const url = this.props.match.url;

        function indexN(cell, row, enumObject, index){

            return (<div>{index+strt}</div>)
        }

        function formatStatus(cell, row, enumObject, index){
            if(row.user_status === '1'){
                return ("Aktif");
            }else{
                return ("Non-Aktif");
            }
        }


        function normalizeLevelName(cell, row, enumObject, index){
            let lev = row.user_level;
            return fp.startCase(lev.replace("_", " "))
        }

        const options = {
            hideSizePerPage: true,
            paginationSize: 3,
            hidePageListOnlyOnePage: true,
            alwaysShowAllBtns: false,
            withFirstAndLast: false,
            clearSearch: true,
            searchPosition: 'left',
            sortName : this.state.sortName,
            sortOrder : this.state.sortOrder,
            onSortChange : this.onSortChange.bind(this)
        }

        return (                    
            <div className="col-sm-12">
                <CPassModal
                    isShow={this.state.isModalPassShow}
                    toggleModalPass={this.toggleModalPass}
                    handleSubmit={this.handleSubmitChangePass}
                    modalHeaderText="Change Password"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    userId = {this.state.userId}
                    userUserName = {this.state.userUserName}
                    userNama = {this.state.userNama}
                    modalSubmitText="Ya" />
                <CStatusModal
                    isShow={this.state.isModalStatusShow}
                    toggleModalStatus={this.toggleModalStatus}
                    handleSubmit={this.handleSubmitChangeStatus}
                    modalHeaderText="Change Status"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    userId = {this.state.userId}
                    userUserName = {this.state.userUserName}
                    userNama = {this.state.userNama}
                    statusExist = {this.state.statusExist}
                    modalSubmitText="Ya" />
                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                    <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-block">
                        { sortirLevel === 'siswa' || sortirLevel === 'wali' || sortirLevel === 'guru'  ? "" : 
                            <NavLink 
                                to={`${this.props.match.url}/add?l=${sortirLevel}`} 
                                className="btn btn-primary"
                            >
                                Tambah {levelName}
                            </NavLink>
                        }
                        &nbsp;&nbsp;
                        {sortirLevel == "siswa"?
                            <div>
                                <NavLink 
                                    to={`${this.props.match.url}/siswapkl?l=${sortirLevel}`} 
                                    className="btn btn-primary"
                                >
                                    Siswa Absensi GPS
                                </NavLink>
                                &nbsp;&nbsp;
                                <NavLink 
                                    to={`${this.props.match.url}/add?l=${sortirLevel}`} 
                                    className="btn btn-primary"
                                >
                                    Tambah {levelName}
                                </NavLink>
                                &nbsp;&nbsp;
                                <button
                                    className="btn btn-primary"
                                    onClick={this.exportFile}>Export Data {levelName}
                                </button>
                                &nbsp;&nbsp;
                                {/*{localStorage.SISMART_USER_USERNAME == 'root@master.com' ?*/}

                                {/*    <NavLink*/}
                                {/*        to={`${this.props.match.url}/importsiswa?l=${sortirLevel}`}*/}
                                {/*        className="btn btn-primary"*/}
                                {/*    >*/}
                                {/*        Import {levelName}*/}
                                {/*    </NavLink>*/}
                                {/*:""}*/}
                                <NavLink
                                    to={`${this.props.match.url}/importsiswa?l=${sortirLevel}`}
                                    className="btn btn-primary"
                                >
                                    Import {levelName}
                                </NavLink>
                                {" "}
                                <NavLink
                                    to={`${this.props.match.url}/dataujian?l=${sortirLevel}`}
                                    className="btn btn-primary"
                                >
                                    Data Peserta Ujian {levelName}
                                </NavLink>
                            </div>
                        :""}
                        &nbsp;&nbsp;
                        {sortirLevel == "wali"?
                            <div>
                                <NavLink 
                                    to={`${this.props.match.url}/add?l=${sortirLevel}`} 
                                    className="btn btn-primary"
                                >
                                    Tambah {levelName}
                                </NavLink>
                            </div>
                        :""}

                        {
                            sortirLevel === 'guru' ? (
                                <div>
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.exportFileGuru}>Export Data {levelName}
                                    </button>
                                    &nbsp;&nbsp;
                                    <NavLink 
                                        to={`${this.props.match.url}/gurugps?l=${sortirLevel}`} 
                                        className="btn btn-primary"
                                    >
                                        Guru Absensi GPS
                                    </NavLink>

                                    &nbsp;&nbsp;
                                    <NavLink 
                                        to={`${this.props.match.url}/add?l=${sortirLevel}`} 
                                        className="btn btn-primary"
                                    >
                                        Tambah {levelName}
                                    </NavLink>

                                    &nbsp;&nbsp;
                                    {/*{localStorage.SISMART_USER_USERNAME == 'root@master.com' ?*/}
                                    
                                    {/*<NavLink*/}
                                    {/*    to={`${this.props.match.url}/importguru?l=${sortirLevel}`}*/}
                                    {/*    className="btn btn-primary" >*/}
                                    {/*    Import {levelName}*/}
                                    {/*</NavLink>*/}

                                    {/*:""}*/}
                                    <NavLink
                                        to={`${this.props.match.url}/importguru?l=${sortirLevel}`}
                                        className="btn btn-primary" >
                                        Import {levelName}
                                    </NavLink>
                                    
                                </div>
                            ) : " "
                        }
                        &nbsp;&nbsp;

                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Data {levelName}
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp(levelName);
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-6 form-group row">
                                <label className="col-md-12 form-control-label">
                                    <b>Filter Data</b>
                                </label>
                                <div className="col-md-6">
                                    <input
                                        name="user_name"
                                        type="text"
                                        className="form-control"
                                        placeholder="Ketikkan Nama Pengguna ..."
                                        value={this.state.user_name}
                                        onChange={this.handleChange}
                                        />
                                </div>
                                {
                                    sortirLevel === 'siswa' ? (
                                        <div className="col-md-6">
                                            <FormDropdown
                                                items={this.state.dataKelas}
                                                onChange={this.handleChange}
                                                value={this.state.kelas_id.toString()}
                                                name="kelas_id"
                                            />
                                        </div>
                                    ) : ''
                                }
                            </div> {/* end col-md-6 form-group row */}
                            
                            <div className="col-md-6 form-group row">

                                { 
                                    /*sortirLevel === 'siswa' || sortirLevel === 'guru' ? (
                                        <label className="col-md-12 form-control-label">
                                            <b>Range Tanggal Export Presensi</b>
                                        </label>
                                    ) : " "*/
                                }

                                {/*<div className="col-md-4">

                                    { 
                                        sortirLevel === 'siswa' ? (
                                            <DatePicker
                                                selected={this.state.dateStart}
                                                onChange={this.handleChangeDatepickerStart}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={15}
                                            />
                                        ) : " " 
                                    }

                                     { 
                                        sortirLevel === 'guru' ? (
                                            <DatePicker
                                                selected={this.state.dateStart}
                                                onChange={this.handleChangeDatepickerStartGuru}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={15}
                                            />
                                        ) : " " 
                                    }

                                </div>*/}

                                {/*{ sortirLevel === 'siswa' || sortirLevel === 'guru'  ? ( "-" ) : " " }*/}

                                {/*<div className="col-md-4">

                                    { 
                                        sortirLevel === 'siswa' ? (
                                            <DatePicker
                                                selected={this.state.dateEnd}
                                                onChange={this.handleChangeDatepickerEnd}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={15}
                                            />
                                        ) : " " 
                                    }

                                    { 
                                        sortirLevel === 'guru' ? (
                                            <DatePicker
                                                selected={this.state.dateEnd}
                                                onChange={this.handleChangeDatepickerEndGuru}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={15}
                                            />
                                        ) : " " 
                                    }


                                </div>*/}
                            </div> {/* end col-md-6 form-group row */}
                            
                        </div>
                        
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataUsers.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <BootstrapTable data={this.state.dataUsers} striped hover remote options={options}>
                                            <TableHeaderColumn width='50' dataField="any" dataFormat={indexN} isKey>No</TableHeaderColumn>
                                            <TableHeaderColumn width='150' dataField="user_nama" dataSort dataFormat={this.nameFormat} >Nama Lengkap</TableHeaderColumn>
                                            <TableHeaderColumn width='150' dataField="user_username" dataSort>Username</TableHeaderColumn>
                                            <TableHeaderColumn width='150' dataField="user_level" dataSort dataFormat={normalizeLevelName}>Level</TableHeaderColumn>
                                            <TableHeaderColumn width='100' dataField="user_status" dataFormat={formatStatus} dataSort>Status</TableHeaderColumn>
                                            <TableHeaderColumn width='150' dataField="button" dataFormat={this.formatOpsi.bind(this)}>Opsi</TableHeaderColumn>
                                        </BootstrapTable>
                                    </div>                                        
                                )
                            )
                        }
                        <hr/>
                        <Paging
                            handlePageClick={this.handlePageClick.bind(this)}
                            pageCount={this.state.pageCount}
                            currentPage={this.state.currentPage}
                        />
                    </div>

                </div>
            </div>                   
        )
    }
}

export default Lists;


// WEBPACK FOOTER //
// ./src/views/Users/Lists.js